export default __webpack_public_path__ + "static/media/connectionLostIcon.12f673b6.svg";